import { render } from "./SelectWorkstageModal.vue?vue&type=template&id=fc2cc56e"
import script from "./SelectWorkstageModal.vue?vue&type=script&lang=js"
export * from "./SelectWorkstageModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__